export default "__VITE_ASSET__C$O5CBmE__"